export const errorCodes = {
  creditRating: {
    isSubscribed: 1096,
  },
};
